<template>
  <v-dialog v-model="showDialog" v-if="showDialog" persistent scrollable :max-width="maxWidth || 775" :width="setWidth" v-on:keydown.enter="defaultButtonAction">
    <v-card>
      <v-card-title class="py-3 font-weight-medium base-dialog__title resBlue darken-1 white--text">
        <v-icon v-if="showTitleIcon"
                :size="titleIconSize"
                class="mr-2"
                color="white">
        </v-icon>
        <span class="resBlue darken-1 white--text body-2">
          {{ dialogTitle }}
        </span>
        <v-spacer></v-spacer>
        <v-icon @click="cancel" color="white">close</v-icon>
      </v-card-title>
      <v-card-text :style="calculateHeight" class="base-dialog px-4">

        <v-row class="pt-2">
          <v-col cols="5" class="res-col-10">
            <label>Budget Group Type</label>
            <group-type-selector v-model="group.groupType" :filled="isSystemGroup" :readonly="isSystemGroup" @input="groupTypeChanged"></group-type-selector>
          </v-col>
          <v-col cols="7" class="res-col-10">
            <label>Budget Group Name</label>
            <res-text-field v-model="group.groupName" :filled="isSystemGroup" :readonly="isSystemGroup" placeholder="Budget group name goes here"></res-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="res-col-10">
            <span class="font-weight-bold">GL Accounts:</span><br />

            Please select the GL Accounts you wish to add by clicking on the available accounts below.  You can always remove accounts from the selected column.
          </v-col>
        </v-row>

        <res-two-list-select listType="GL Accounts" v-model="selectedGLAccountList" :allSelectable="selectableGLAccounts" :readonly="readonly"></res-two-list-select>

      </v-card-text>
      <v-card-actions class="px-4 pt-0 pb-4 d-flex justify-end">
        <v-spacer></v-spacer>
        <v-btn 
          height="30px" 
          rounded elevation="0" 
          outlined 
          :color="cancelButtonColor" 
          @click="cancel">
          {{ cancelButtonText }}
        </v-btn>
        <v-btn 
          v-if="readonly === false"
          height="30px" 
          rounded elevation="0" 
          :disabled="isSaveDisabled" 
          class="resGreen white--text" 
          width="[saveButtonWidth ? saveButtonWidth : '']" 
          @click="save">
          {{ saveButtonText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import ResTextField from '@/components/base/ResTextField.vue';
  import ResTwoListSelect from '@/components/base/ResTwoListSelect.vue';
  import GroupTypeSelector from '@/components/templates/budget-groups/GroupTypeSelector.vue';
  import IsNullOrWhitespaceMixin from '@/mixins/isNullOrWhitespace.js';
  import templateService from '@/services/template'
  import groupService from '@/services/group'
  import { mapActions } from 'vuex'

  export default {
    name: 'NewEditGroupDialog',
    components: {
      ResTextField,
      ResTwoListSelect,
      GroupTypeSelector
    },
    data: function () {
      return {
        glAccountsByType: [],
        group: {
          groupType: {
            value: "1",
            text: 'Income'
          }
        },
        selectedGLAccountList: []
      }
    },
    props: {
      showDialog: {
        type: Boolean
      },
      mode: {
        type: String
      },
      groupId: {
        type: String
      },
      templateId: {
        type: String
      },
      maxWidth: {
        type: Number
      },
      setWidth: {
        type: Number
      },
      setHeight: {
        type: Number
      },
      readonly: {
        type: Boolean
      }
    },
    mixins: [IsNullOrWhitespaceMixin],
    methods: {
      ...mapActions(['changeLoading']),
      save() {
        if (!this.isSaveDisabled) {
          var selectedGLAccountIds = self._.map(this.selectedGLAccountList, function (gl) { return gl.value });
          var groupData = { groupName: this.group.groupName, groupTypeId: this.group.groupType.value, lastModifiedTimestamp: this.group.lastModifiedTimestamp || null };
          this.$emit('save', selectedGLAccountIds, groupData);
        }
      },
      cancel() {
        this.$emit('cancel', true)
      },
      async getGLAccountsByGroupType(groupTypeId) {
        var self = this;
        self.changeLoading(true);
        try {
          let result = await templateService.getGLAccountsByGroupTypeId(self.templateId, groupTypeId);
          if (result) {
            self.glAccountsByType = result;
          }
        }
        catch (ex) {
          console.log(ex);
        }
        self.changeLoading(false);
      },
      groupTypeChanged(newType) {
        this.getGLAccountsByGroupType(newType.value);
        this.selectedGLAccountList = [];
      }
    },
    computed: {
      dialogTitle() {
        if (this.mode == 'edit') {
          return 'Edit ' + this.group.groupName;
        } else {
          return 'New Budget Group';
        }
      },
      saveButtonText() {
        return this.mode == 'edit' ? 'SAVE' : 'CREATE BUDGET GROUP';
      },
      cancelButtonText() {
        return this.readonly ? 'CLOSE' : 'CANCEL';
      },
      cancelButtonColor() {
        return this.readonly ? 'resBlue darken1' : 'resRed base';
      },
      calculateHeight() {
        return "height:" + this.setHeight + "px";
      },
      isSaveDisabled() {
        if (this.isNullOrWhitespace(this.group.groupName) || this.isNullOrWhitespace(this.group.groupType.text)) {
          return true;
        }
        return false;
      },
      showTitleIcon() {
        return this.mode == 'copy';
      },
      selectableGLAccounts() {
        var glAccounts = this._.map(this.glAccountsByType, function (glAccount) {
          return { text: `${glAccount.glAccountNumber}- ${glAccount.glAccountName}`, value: glAccount.glAccountId }
        });
        return glAccounts;
      },
      isSystemGroup() {
        if (this.mode == 'edit' && this.group.isSystem) {
          return true;
        }
        return false;
      }
    },
    async mounted() {
      var self = this;
      self.changeLoading(true);

      if (self.mode == 'edit') {
        //Mount the current Group data
        try {
          let groupRes = await groupService.get(self.groupId, self.templateId);
          if (groupRes) {
            self.group = groupRes;
            self.group.groupType = { value: groupRes.groupTypeId.toString(), text: groupRes.groupTypeName };
            self.selectedGLAccountList = self._.map(self.group.glAccounts, function (gl) { return { text: `${gl.glAccountNumber} - ${gl.glAccountName}`, value: gl.glAccountId } });
          }
        }
        catch (ex) {
          console.log(ex);
        }
      }
      else {
        self.group = { groupType: { value: "1", text: 'Income' } };
      }

      await self.getGLAccountsByGroupType(self.group.groupType.value);
    }
  };
</script>

<style lang="scss" scoped>
  .base-dialog {
    .res-col-10
    {
      padding-top: 10px !important;
      padding-bottom: 10px !important;
    }

    .v-btn-toggle--rounded {
      border-radius: 6px;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
    }
  }

  .v-input.v-input--dense.v-text-field.v-text-field--outlined::v-deep {
    .v-input__slot
    {
      min-height: 30px !important;
      border-radius: 6px;
    }
  }

  .theme--light.v-btn-toggle::v-deep {
    .v-btn.v-btn
  {
    border: solid 1px var(--v-resGrey-darken1) !important;
  }

  }

  .v-input.v-input--dense.v-input--selection-controls.v-input--radio-group.v-input--radio-group--row::v-deep {
    .v-messages

  {
    display: none;
  }

  .v-input__slot {
    margin-bottom: 0px !important
  }

  .v-input--selection-controls__input {
    height: 20px !important;
    width: 20px !important;
  }

  .v-input--selection-controls__ripple {
    width: 20px;
    height: 20px;
    left: -10px;
  }

  .v-icon--svg {
    height: 15px !important;
    width: 15px !important;
  }

  }

  .v-input.future-period-start-selector::v-deep {
    div.menuable__content__active {
    max-height: 132px !important;
  }
  } 
</style>

